<template>
	<div>
		<LoadingSpinner v-if="processing" />
		<div v-else-if="sync_history.length == 0">
			<b-alert show variant="warning">
				{{ $t('sync_groomy.acte_no_sync') }}
			</b-alert>
		</div>
		<table v-else class="table b-table table-striped table-hover table-borderless table-variante table-task">
			<thead>
				<tr>
					<th>{{ $t('sync_groomy.history_type.title') }}</th>
					<th>{{ $t('sync_groomy.history_author') }}</th>
					<th>{{ $t('sync_groomy.history_date_time') }}</th>
					<th>{{ $t('sync_groomy.history_values') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="history in sync_history" :key="history.syncdatahistory_id">
					<td>{{ $t('sync_groomy.history_type.'+history.syncdatahistory_type) }}</td>
					<td>
						<template v-if="history.syncdatahistory_author">{{ history.syncdatahistory_author }}</template>
						<template v-else>{{ $t('sync_groomy.vous') }}</template>
					</td>
					<td>{{ history.syncdatahistory_inserted }}</td>
					<td>
						{{ $t('sync_groomy.acte_data.type') }} : {{ history.syncdatahistory_value.actes_actestype }}<br>
						{{ $t('sync_groomy.acte_data.date') }} : {{ history.syncdatahistory_value.actes_date }}<br>
						{{ $t('sync_groomy.acte_data.commetaire') }} : {{ history.syncdatahistory_value.actes_commentaire }}<br>
						{{ $t('sync_groomy.acte_data.reponses') }} :
						<ul>
							<li v-for="(reponse, index) in history.syncdatahistory_value.reponses" :key="index">{{ reponse }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
    import ActeMixin from "@/mixins/Actes.js"
    import dateFormat from "dateformat"

	export default {
		name: 'SyncActHistory',
		props: ['acte_id'],
		mixins: [ActeMixin],
		data () {
			return {
				processing: true,
				sync_history: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				const sync_history = await this.getActeSyncGroomyHistory(this.acte_id)
				this.sync_history = sync_history.map(history => {
					const responses = history.syncdatahistory_value.reponses.map(reponse => {
						const question_libelle = Vue.i18n.translate('questions.' + [reponse.reponse_question])
						if(reponse.reponse_data[0] === true) {
							return question_libelle + ": " + Vue.i18n.translate('global.oui')
						} else if(reponse.reponse_data[0] === false) {
							return question_libelle + ": " + Vue.i18n.translate('global.non')
						} else {
							if(Array.isArray(reponse.reponse_data)) {
								return question_libelle + ": " + reponse.reponse_data.map(
									(d) => (typeof d === 'object' && d !== null ?
											(Vue.i18n.translate('reponses.' + [d.value]).includes('reponses.') ? d.value : Vue.i18n.translate('reponses.' + [d.value]))
										: 
											(Vue.i18n.translate('reponses.' + [d]).includes('reponses.') ? d : Vue.i18n.translate('reponses.' + [d])))
								).join(', ')
							}
							else {
								return reponse.reponse_data
							}
					
						}
					})
					history.syncdatahistory_value.reponses = responses
					history.syncdatahistory_value.actes_actestype = Vue.i18n.translate('actes_type.' + history.syncdatahistory_value.actes_actestype)
					history.syncdatahistory_value.actes_date = this.formatDate(history.syncdatahistory_value.actes_date)

					history.syncdatahistory_inserted = this.formatDateTime(history.syncdatahistory_inserted)

					return history
				})
				this.processing = false
			},

			formatDateTime: function(date) {
	            if(!date) {
	                return ''
	            }
	            let date_config = JSON.parse(window.localStorage.getItem('format_date')) ?? 'd/m/Y'
	            date_config = date_config.replace('y', 'yy').replace('Y', 'yyyy').replace('d', 'dd').replace('m', 'mm')
	            date_config += ' H:mm'
	            
	            let date_obj = Date.parseTz(date)
	            return date_obj == 'Invalid Date' ? date_obj : dateFormat(date_obj, date_config)
	        }
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>